module.exports = __webpack_public_path__ + "img/ages.0690766.svg";